import React, { useState } from "react";

import { ThemeProvider } from "styled-components";
import theme from "./theme";

import GlobalStyle from "./App.style";

import Header from "./components/Header";
import Map from "./components/Map";
import MobileHeader from "./mobile/components/MobileHeader";
import Notifications from "./components/Notifications";

import { isMobile, BrowserView, MobileView } from "react-device-detect";

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

function App() {
  const [displayPopupWallet, setDisplayPopupWallet] = useState(false);

  const landsMap = (
    <Map
      displayPopupWallet={displayPopupWallet}
      onDisplayPopupWallet={(isVisible) => setDisplayPopupWallet(isVisible)}
    />
  );
  return (
    <ThemeProvider theme={isMobile ? theme.mobile : theme.desktop}>
      <Router>
        <BrowserView>
          <>
            <Header onDisplayPopupWallet={(isVisible) => setDisplayPopupWallet(isVisible)} />
            <Routes>
              <Route path="*" element={landsMap} />
            </Routes>
            <Notifications />
          </>
          <GlobalStyle />
        </BrowserView>

        <MobileView>
          <>
            <MobileHeader onDisplayPopupWallet={(isVisible) => setDisplayPopupWallet(isVisible)} />
            <Routes>
              <Route path="*" element={landsMap} />
            </Routes>
            <Notifications />
          </>
          <GlobalStyle />
        </MobileView>
      </Router>
    </ThemeProvider>
  );
}

export default App;
